<template>
  <div>
    <Dropdown text="О товаре" :isOpen="true" v-if="isRichContent">
      <template v-slot:content>
        <RichContentBlock />
      </template>
    </Dropdown>
    <Dropdown text="Описание" v-if="isRichContent">
      <template v-slot:content>
        <div class="mt-16">
          <ProductDetailsApp />
        </div>
      </template>
    </Dropdown>
    <Dropdown text="Характеристики" v-if="isRichContent">
      <template v-slot:content>
        <div class="pt-8">
          <Utp />
          <Characteristic />
        </div>
      </template>
    </Dropdown>

    <Dropdown text="О товаре" v-if="!isRichContent">
      <template v-slot:content>
        <div class="fw-medium fs-20">Характеристики</div>
        <div class="pt-8">
          <Utp />
          <Characteristic />
        </div>
        <div class="fw-medium fs-20 mt-32">Описание</div>
        <div class="mt-16">
          <ProductDetailsApp />
        </div>
      </template>
    </Dropdown>

    <Dropdown text="Наличие в салоне" v-if="canReserve">
      <template v-slot:content>
        <Availability
          :active="true"
          :mapId="'availability-yandex-map-mobile'"
        />
      </template>
    </Dropdown>

    <Dropdown text="Отзывы">
      <template v-slot:content>
        <!-- Нет отзывов -->
        <div v-if="getReviewsCount === 0">
          На этот товар пока нет отзывов — ваш может стать первым
          <div class="mt-8 color-gray">
            Расскажите о ваших впечатлениях о покупке
          </div>

          <div class="grid-row d-flex_sm-wrap grid-row_md mt-24" v-if="isAuth">
            <div class="grid-col grid-col_sm-100">
              <PopupLeaveReview />
            </div>
          </div>
        </div>

        <div v-if="getReviewsCount > 0" class="mt-16">
          <SliderReviews />
        </div>
      </template>
    </Dropdown>

    <Dropdown text="Вопросы">
      <template v-slot:content>
        <!-- Нет вопросов -->
        <div v-if="getQuestionsCount === 0">
          Об этом товаре пока нет вопросов — задайте его сейчас, и специалист
          ответит вам в ближайшее время

          <div class="grid-row d-flex_sm-wrap grid-row_md mt-24">
            <div class="grid-col grid-col_sm-100">
              <PopupLeaveQuestion />
            </div>
          </div>
        </div>

        <!-- Есть вопросы -->
        <div v-if="getQuestionsCount > 0" class="mt-16">
          <SliderQuestions />
        </div>
      </template>
    </Dropdown>

    <Dropdown v-if="getDocuments?.length" text="Документы">
      <template v-slot:content>
        <template v-for="(item, key) in getDocuments" :key="key">
          <DocLink :text="item.name" :link="item.path" />
        </template>
      </template>
    </Dropdown>
  </div>
</template>

<script>
import Characteristic from "../Characteristic/Characteristic.vue";
import Dropdown from "../Dropdown/Dropdown.vue";
import ProductDetailsApp from "../DescriptionBlock/DescriptionBlock";
import Availability from "../Availability/AvailabilityMain.vue";
import SliderReviews from "../Sliders/SliderReviews.vue";
import SliderQuestions from "../Sliders/SliderQuestions.vue";
import PopupLeaveReview from "../Popups/PopupLeaveReview.vue";
import Utp from "../DetailsBlock/DetailsBlock";
import DocLink from "../DocLink/DocLink.vue";
import { mapState } from "pinia";
import { useReviewsStore } from "@/pages/product_card/stores/store_reviews";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import PopupLeaveQuestion from "../Popups/PopupLeaveQuestion.vue";
import RichContentBlock from "@/pages/product_card/components/RichContentBlock/RichContentBlock.vue";

export default {
  name: "CharacteristicDropdown",
  components: {
    RichContentBlock,
    Characteristic,
    Dropdown,
    ProductDetailsApp,
    Availability,
    SliderReviews,
    SliderQuestions,
    PopupLeaveReview,
    DocLink,
    Utp,
    PopupLeaveQuestion,
  },
  data() {
    return {
      isActive: false,
      isAuth: window.isAuth,
    };
  },
  computed: {
    ...mapState(useReviewsStore, ["getQuestionsCount", "getReviewsCount"]),
    ...mapState(useProductStore, [
      "getDocuments",
      "canReserve",
      "isRichContent",
    ]),
  },
  methods: {
    toogleStates() {
      this.isActive = !this.isActive;
    },
  },
};
</script>
